import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import SelectField from "../../../Form/SelectField/SelectField";
import { PAGE_SIZE_OPTIONS } from "./constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PageSizeSelector = _ref => {
  let {
    id = 'pagination',
    className = '',
    pageSize,
    setPageSize,
    setPageNumber,
    defaultPageSize = 10,
    dataTestElement = "page_size_selector"
  } = _ref;
  return /*#__PURE__*/_jsx(SelectField, {
    className: cn('flex items-center space-x-2', className),
    listBoxUpOptionsClassName: "absolute bottom-46 outline-solid focus:outline-solid",
    label: /*#__PURE__*/_jsxs("span", {
      children: ["Show", /*#__PURE__*/_jsx("span", {
        className: "inset-0 sr-only",
        children: "items per page"
      })]
    }),
    id: id,
    dataTestElement: dataTestElement,
    onChange: value => {
      setPageSize(parseInt(value || defaultPageSize));
      setPageNumber(1);
    },
    value: pageSize.toString(),
    options: PAGE_SIZE_OPTIONS.map(val => ({
      label: val.toString(),
      value: val.toString()
    })),
    valueKey: "value",
    labelKey: "label",
    truncateOptions: false
  });
};
PageSizeSelector.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  pageSize: PropTypes.number.isRequired,
  defaultPageSize: PropTypes.number,
  setPageSize: PropTypes.func.isRequired,
  setPageNumber: PropTypes.func.isRequired
};
export default PageSizeSelector;
//# sourceMappingURL=PageSizeSelector.js.map